// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.imgDialog[data-v-30ad7ae4] {\n  z-index: 10;\n}\n.imgDialog[data-v-30ad7ae4] .el-dialog__header {\n  padding: 0 20px;\n}\n.imgDialog[data-v-30ad7ae4] .el-dialog__body {\n  padding-top: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
